import { render, staticRenderFns } from "./Addadminclub.vue?vue&type=template&id=12e92704&scoped=true&"
import script from "./Addadminclub.vue?vue&type=script&lang=js&"
export * from "./Addadminclub.vue?vue&type=script&lang=js&"
import style0 from "./Addadminclub.vue?vue&type=style&index=0&id=12e92704&lang=less&scoped=true&"
import style1 from "./Addadminclub.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e92704",
  null
  
)

export default component.exports